<h2 mat-dialog-title>
  {{ 'dataExport.deviceSelectionDialog.title' | translate }}
</h2>

<mat-dialog-content class="device-selection-dialog__content">
  <xemex-search-input
    [value]="searchTerm()"
    [placeholder]="'dataExport.deviceSelectionDialog.searchPlaceholder' | translate"
    size="lg"
    (valueChange)="onSearchChange($event)"
  />

  <xemex-table
    [data]="tableData()"
    [columns]="columns"
    [selectable]="true"
    [pageable]="true"
    [totalCount]="totalCount()"
    [selectionKey]="selectionKey"
    [selectedKeys]="selectedKeys()"
    [selectAllAcrossPages]="true"
    [loading]="selectingAll()"
    (selectedKeysChange)="onSelectedKeysChange($event)"
    (selectAllRequested)="onSelectAllRequested($event)"
    (pageChange)="onPageChange($event)"
  />
</mat-dialog-content>

<mat-dialog-actions align="end" class="device-selection-dialog__actions">
  <span class="device-selection-dialog__count">
    {{ 'dataExport.deviceSelectionDialog.selected' | translate: { count: selectedCount() } }}
  </span>
  <xemex-text-button type="button" (click)="onCancel()">
    {{ 'dataExport.deviceSelectionDialog.cancel' | translate }}
  </xemex-text-button>
  <xemex-filled-button type="button" (click)="onApply()">
    {{ 'dataExport.deviceSelectionDialog.apply' | translate }}
  </xemex-filled-button>
</mat-dialog-actions>
